import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICompany } from '../entities/admin-panel/company.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class UserCompaniesHttpService extends ApiService {
  getUserCompanies(): Observable<ICompany[]> {
    return this.http.get<ICompany[]>(`${this.api}/user-companies`);
  }
}
